//import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Transition from './Dialogs/Transition';

const styles = {
	row : {
		paddingBottom : 10,
	},
	label : {
		marginRight : 10,
	},
	value : {
		fontWeight : 600,
	},
	current : {

	},
	new : {
		marginTop : 20,
	},
	section : {
		margin : '30px 0px 10px 0px',
		textAlign : 'left',
	},
	sectionHeader : {
		textTransform : 'uppercase',
		fontSize : 14,
		color : '#777',
		fontWeight : 900,
		letterSpacing : 2,
	},
};

export default class DcNotificationJobDialog extends Component {

	constructor (props) {
		super(props);
		this.handleClose = this.handleClose.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	handleClose() {
		this.props.onClose();
	}

	handleDelete() {
		const notificationJobId = this.props.notificationJob.notificationJobId;
		this.props.removeNotificationJob({
			notificationJobId,
			callback : function (err) {
				if (!err) { this.props.onClose(); }
			}.bind(this)
		});
	}

	render() {
		const { notificationJob, stationMap } = this.props;
		if (!notificationJob) { return null; }

		const stations = notificationJob.stationIds.map(stationId => {
			return stationMap[stationId];
		});

		return (
			<Dialog
				maxWidth='md'
				open={this.props.open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
			>
				<DialogTitle>
					{notificationJob.number} - {notificationJob.name}
				</DialogTitle>
				<DialogContent>
					<div style={styles.section}>
						<div style={styles.sectionHeader}>Stations</div>
					</div>
					{stations.map((station, i) => {
						return (
							<div key={i} style={styles.row}>
								<span style={styles.label}>{station.number} - {station.name}</span>
							</div>
						);
					})}

					<div style={styles.section}>
						<div style={styles.sectionHeader}>Emails</div>
					</div>
					{notificationJob.emails.map((email, i) => {
						return (
							<div key={i} style={styles.row}>
								<span style={styles.label}>{email}</span>
							</div>
						);
					})}

					<div style={{padding:20, fontWeight : 900, fontSize : 18}}>
						Are you sure you want to delete this Notification Job ?
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose}>
						Close
					</Button>
					<Button variant="contained" onClick={this.handleDelete} style={{backgroundColor : '#F44336', color : 'white'}}>
						Yes, Delete this Job
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

DcNotificationJobDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	notificationJob : PropTypes.object,
	stationMap : PropTypes.object,
	removeNotificationJob : PropTypes.func.isRequired,
};